import styled from 'styled-components';

const fontGrey = '#6C6B7C';

const ChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${(props) => props.theme.colors.light};
  max-height: 500px;
`;

const Line = styled.path`
  fill: none;
`;

const XAxis = styled.g`
  font-size: ${(props) => props.theme.size.small};
  text {
    fill: ${fontGrey};
  }
  .domain {
    stroke: ${(props) => props.theme.colors.light_darker_1};
  }
  .tick line {
    stroke: none;
  }
`;

const XAxisGrid = styled.g`
  .domain {
    stroke: none;
  }
  .tick {
    &:nth-child(2) line {
      stroke-dasharray: 0;
    }
    & line {
      stroke-dasharray: 5 5;
      stroke: ${(props) => props.theme.colors.light_darker_1};
    }
  }
`;

const YAxis = styled.g`
  font-size: ${(props) => props.theme.size.small};
  text {
    fill: ${fontGrey};
  }
  .domain {
    stroke: none;
  }
  .tick line {
    stroke: none;
  }
`;

const YAxisGrid = styled.g`
  .domain {
    stroke: none;
  }
  .tick line {
    stroke: ${(props) => props.theme.colors.light_darker_1};
  }
`;

const CircleLabel = styled.text`
  font-size: ${(props) => props.theme.size.small};
  fill: ${fontGrey};
  text-anchor: middle;
  alignment-baseline: center;
`;

const LabelWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: ${(props) => props.theme.spacing.large};
`;

const LabelCircle = styled.div`
  background-color: ${(props) => props.color};
  border-radius: 50%;
  width: 15px;
  height: 15px;
  display: inline-flex;
  margin-right: ${(props) => props.theme.spacing.small};
`;

const LabelText = styled.div`
  color: ${(props) => props.theme.colors.dark};
  font-size: ${(props) => props.theme.size.xbody};
  display: inline-flex;
`;

const HiddenCircle = styled.circle`
  fill: transparent;
  stroke: transparent;
  &:hover {
    fill: ${(props) => props.color};
    stroke: ${(props) => props.color};
  }
`;

export {
  ChartWrapper,
  Line,
  XAxis,
  XAxisGrid,
  YAxis,
  YAxisGrid,
  HiddenCircle,
  CircleLabel,
  LabelWrapper,
  LabelCircle,
  LabelText
};
